// extracted by mini-css-extract-plugin
export default {"root":"hcx-card-summary-activity_root__YK8uG","teamLogo":"hcx-card-summary-activity_teamLogo__SQW7n"};